var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ApolloProvider } from '@apollo/client';
import { apolloClient } from '../../apollo';
import VerifyEmail from './VerifyEmail';
import { ViewerProvider } from '../../context/viewer-context';
import { RouterProvider } from '../../context/router-context';
import { SnackbarPortal } from '../common/snackbar-portal';
export default function AppProviders(_a) {
    var children = _a.children;
    return (_jsx(ApolloProvider, __assign({ client: apolloClient }, { children: _jsx(RouterProvider, { children: _jsxs(ViewerProvider, { children: [_jsx(SnackbarPortal, {}, void 0),
                    _jsx(VerifyEmail, { children: children }, void 0)] }, void 0) }, void 0) }), void 0));
}
//# sourceMappingURL=AppProviders.js.map